import { getAbsoluteRoute } from '@helpers/route';
import { LicenceHolderService } from '@services/licence_holder.service';
import { useService } from '@visiba/instantiation';
import { useLocation } from 'react-router';

export function useRouteDetails(relativeTo: string): [to: string, isCurrentPage: boolean] {
	const licenceHolderService = useService(LicenceHolderService);

	let absoluteTo = getAbsoluteRoute(relativeTo);
	let isCurrentPage: boolean;
	if (window.__TEMP__) {
		const pathname = window.location.pathname.replace(/\/$/, '');
		isCurrentPage =
			absoluteTo === getAbsoluteRoute(licenceHolderService.alias) ? pathname === absoluteTo : pathname.includes(absoluteTo);

		// For Angular in injection
		absoluteTo = relativeTo;
	} else {
		// This is a quite illegal thing to do and could potentially break stuff if
		// not cared for correctly.
		// We will guarantee that this hook may never be called conditionally
		// between renders since "__TEMP__navigate" will never be conditionally
		// passed down.
		// eslint-disable-next-line react-hooks/rules-of-hooks
		const { pathname } = useLocation();
		isCurrentPage = pathname.replace(/\/$/, '') === absoluteTo.replace(/\/$/, '');
	}

	return [absoluteTo, isCurrentPage];
}
